<template>
  <vx-card no-shadow>
    <h2 class="mb-6">User - Venues</h2>

    <vs-table
      v-if="user"
      ref="table"
      class="mt-8"
      v-model="selected"
      :data="user.venues"
      @selected="onVenueClicked(selected)"
    >
      <!--
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div
            @click="onAssignToVenue"
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Assign to Venue</span
            >
          </div>
        </div>
      </div>
      -->

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="venueRole">Role</vs-th>
        <!--
          <vs-th>Action</vs-th>
        -->
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.venueRole }}</p>
            </vs-td>

            <!--
            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr.id)"
              />
            </vs-td>
            -->
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup
      title="Assign User to Venue"
      :active.sync="assignToVenuePopupActive"
    >
      <div>
        <p>Select Venue:</p>
        <vs-button 
          v-if="assignmentVenues && assignedVenue"
          @click="assignedVenue = null"
          class="mt-2"
          color="success" type="filled" icon-pack="feather">
          {{ assignedVenue.name }}
        </vs-button>

        <vs-table
          v-if="assignmentVenues && !assignedVenue"
          ref="table"
          class="mt-4"
          v-model="selectedAssignmentVenue"
          :data="assignmentVenues"
          @selected="onVenueAssignmentSelected(selectedAssignmentVenue)"
        >
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.name }}</p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <p class="mt-8">Select Role:</p>
        <vs-select class="mt-2"
          v-model="selectedRole"
          >
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in roleOptions" />
        </vs-select>

        <vs-button 
          v-if="assignedVenue"
          @click="assignUserToVenue"
          class="mt-10"
          color="primary" type="filled" icon-pack="feather" icon="done">
          Assign to Venue
        </vs-button>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      user: null,
      selected: null,

      assignToVenuePopupActive: false,
      selectedAssignmentVenue: null,
      assignmentVenues: null,
      selectedRole: 0,
      roleOptions:[
        {text:'Standard', value:0},
        {text:'Venue Manager', value:1}
      ],
      assignedVenue: null
    };
  },
  methods: {
    onAssignToVenue: function () {
      this.getVenues();

      this.assignToVenuePopupActive = true;
    },

    onVenueAssignmentSelected: function (venue) {
      console.log("onVenueAssignmentSelected");
      this.assignedVenue = venue;
    },

    assignUserToVenue: function () {
      this.$vs.loading();

      const payload = {
        userId: this.user.userId,
        role: this.selectedRole
      };

      this.$http
        .post(process.env.VUE_APP_API + '/venue/' + this.assignedVenue.venueId + '/info/users/', payload)
        .then((/*resp*/) => {
          this.assignToVenuePopupActive = false;

          this.getUser(this.user.userId);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getVenues: function () {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/venues?query=*")
        .then((resp) => {
          this.assignmentVenues = resp.data;
          console.log(this.assignmentVenues);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getUser: function (userId) {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/users/" + userId)
        .then((resp) => {
          this.user = resp.data;

          console.log(this.user);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onVenueClicked(/*venue*/) {},

    deleteData(id) {
      console.log("Delete:", id);
    },
  },
  created() {
    this.getUser(this.$route.params.userId);
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>